module.exports = __webpack_public_path__ + "img/notifications/notifications_always_allow-eafad1e116af063dcd7b9acbafee4fbc.gif";